'use client';

import Link from 'next/link';
import { useConfig } from './ConfigProvider';

export function Footer() {
  const { comusflowUrl } = useConfig();
  return (
    <footer className="bg-body-tertiary py-4 border-top mt-auto">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start">
            <span className="text-muted">
              &copy; 2026 ComusLive. Découvrez les concerts et spectacles près de chez vous.
            </span>
          </div>
          <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">
            <Link href="/events" className="text-muted text-decoration-none me-3">
              Tous les événements
            </Link>
            <a href={comusflowUrl} className="text-muted text-decoration-none">
              Publier mes événements
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
